<template>
<div class="chapter">
<div class="inner_page">
<div id="toc" style="font-weight:bold"><h1 id="toc-title">Havana-Merida-Chicago (A Journey to Freedom)</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li>
<li id="toc-li-5"><a href="#/text/ch005#introduction">Introduction</a><ol class="toc"><li id="toc-li-6"><a href="#/text/ch005#food-for-thought">
</a></li>
</ol></li>
<li id="toc-li-7"><a href="#/text/ch006#chapter-one-the-building-of-my-dreams">Chapter One: The Building of My Dreams</a><ol class="toc"><li id="toc-li-8"><a href="#/text/ch006#food-for-thought-1">
</a></li>
</ol></li>
<li id="toc-li-9"><span href="#/text/ch007#chapter-two-the-deception" title="Link target outside of Sample">Chapter Two: The Deception</span><ol class="toc"><li id="toc-li-10"><span href="#/text/ch007#aspirations-and-dreams-to-improve-cuban-economy" title="Link target outside of Sample">
</span></li>
<li id="toc-li-11"><span href="#/text/ch007#the-frustrated-participation-in-the-national-planning-of-the-sugar-crop" title="Link target outside of Sample">
</span></li>
<li id="toc-li-12"><span href="#/text/ch007#food-for-thought-2" title="Link target outside of Sample">
</span></li>
</ol></li>
<li id="toc-li-13"><span href="#/text/ch008#chapter-three-the-search-for-freedom-abroad-mexico" title="Link target outside of Sample">Chapter Three: The Search for Freedom Abroad – Mexico</span><ol class="toc"><li id="toc-li-14"><span href="#/text/ch008#food-for-thought-3" title="Link target outside of Sample">
</span></li>
</ol></li>
<li id="toc-li-15"><span href="#/text/ch009#chapter-four-the-scientific-and-pedagogic-realization-in-merida" title="Link target outside of Sample">Chapter Four: The Scientific and Pedagogic Realization in Merida</span><ol class="toc"><li id="toc-li-16"><span href="#/text/ch009#food-for-thought-4" title="Link target outside of Sample">
</span></li>
</ol></li>
<li id="toc-li-17"><span href="#/text/ch010#chapter-five-seven-days-became-seven-months-in-havana" title="Link target outside of Sample">Chapter Five: Seven Days Became Seven Months in Havana</span><ol class="toc"><li id="toc-li-18"><span href="#/text/ch010#food-for-thought-5" title="Link target outside of Sample">
</span></li>
</ol></li>
<li id="toc-li-19"><span href="#/text/ch011#chapter-six-the-search-for-freedom-during-two-months-in-mexico" title="Link target outside of Sample">Chapter Six: The Search for Freedom During Two Months in Mexico</span><ol class="toc"><li id="toc-li-20"><span href="#/text/ch011#food-for-thought-6" title="Link target outside of Sample">
</span></li>
</ol></li>
<li id="toc-li-21"><span href="#/text/ch012#chapter-seven-the-gate-to-america" title="Link target outside of Sample">Chapter Seven: The Gate to America</span><ol class="toc"><li id="toc-li-22"><span href="#/text/ch012#second-introduction" title="Link target outside of Sample">
</span></li>
</ol></li>
<li id="toc-li-23"><span href="#/text/ch013#chapter-eight-how-antonio-and-gladys-morales-materialized-their-american-dream" title="Link target outside of Sample">Chapter Eight: How Antonio and Gladys Morales Materialized Their American Dream</span><ol class="toc"><li id="toc-li-24"><span href="#/text/ch013#antonios-and-gladys-components-of-their-american-dream" title="Link target outside of Sample">
</span></li>
<li id="toc-li-25"><span href="#/text/ch013#food-for-thought-7" title="Link target outside of Sample">
</span></li>
<li id="toc-li-26"><span href="#/text/ch013#food-for-thought-8" title="Link target outside of Sample">
</span></li>
<li id="toc-li-27"><span href="#/text/ch013#food-for-thought-9" title="Link target outside of Sample">
</span></li>
</ol></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?7d489252